// SPDX-FileCopyrightText: 2017-2026 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import colors from 'lib-customizations/common'

export const green = {
  bg: '#E9F5E6',
  fg: '#397332'
}

export const orange = {
  bg: '#FFF0DB',
  fg: '#74310C'
}

export const blue = {
  bg: '#E5EEF8',
  fg: colors.main.m2
}
